import { MapCluster } from "./map-cluster";
import { Webcam } from "./webcam";
import { MapObject } from "./map-object";

export class MapLayer {

    constructor(public objects:MapObject[], public clusters:MapCluster[], public selected: boolean){
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/map-layer.ts